import * as Sentry from "@sentry/react-router";
import { useEffect } from "react";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useLocation,
  useRouteError,
} from "react-router";
import { ToastContainer } from "react-toastify";
import * as gtag from "~/utils/gtag"
import toastifyStyles from "react-toastify/dist/ReactToastify.min.css?url";
import stylesheet from "~/tailwind.css?url";

export const loader = async () => {
  return { GA_TRACKING_ID: process.env.GA_TRACKING_ID || "G-Y8729YT7D5" }; // TODO: Figure out why not being picked by remix build
};

export function links() {
  return [{ rel: "stylesheet", href: stylesheet },
  { rel: "stylesheet", href: toastifyStyles },
  ]
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  Sentry.captureException(error);
  console.error(error)
  return <div>Something went wrong</div>;
};

export default function App() {
  const location = useLocation();
  const { GA_TRACKING_ID } = useLoaderData<typeof loader>();

  useEffect(() => {
    if (GA_TRACKING_ID?.length) {
      gtag.pageview(location.pathname, GA_TRACKING_ID);
    }
  }, [location, GA_TRACKING_ID]);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        {!GA_TRACKING_ID ? null : (
          <>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
            />
            <script
              async
              id="gtag-init"
              dangerouslySetInnerHTML={{
                __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', '${GA_TRACKING_ID}', {
                  page_path: window.location.pathname,
                });
              `,
              }}
            />
          </>
        )}
        <Meta />
        <Links />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+Mono:wdth,wght@75,400&display=swap"
          rel="stylesheet"
        />
      </head>
      <body className="font-Metropolis relative dark:bg-bg-dark max-w-[1444px] m-auto">

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
